export const getConfigurationInitialState = () => ({
    accessToken: '',
    environment: 'prod',
    organizationId: '',
    analytics: {
        enabled: true,
        trackingId: '',
        source: {},
    },
    commerce: {},
});
